module.exports = __webpack_public_path__ + "img/couples-087.4cf3e73d.jpg";